/* global $settings, initialPageContents */
/* eslint-disable import/prefer-default-export,  no-global-assign */

$settings = $settings || {};

export function isStaticPage() {
  return $settings && $settings.pageType === 'static';
}

export function getInitialPageContents() {
  return initialPageContents || '';
}



// WEBPACK FOOTER //
// ./src/tools/page-utils.js